import React from 'react';
import 'bootstrap';
import 'aos'
import '../assets/css/style.css';
import licaPDF from '../assets/pdf/lica.pdf';

const DownloadBrochure = ({ product }) => {

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = licaPDF;
        link.download = 'Lab Iconics LIMS Brochure.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const bg_color = product ==='LIMS' ? '#E5F2FE' : product ==='ELN' ? '#F7E2F5' : product ==='Industries' ? '#B1DAFD' : '#B1DAFD'; //#2fceff

    return (
        <div className="download-broch">
            <div style={{backgroundColor:'#E5F2FE'}}>
                <div className='broch-title'>Download our Overview Brochure for more information</div>
                <div className='broch-download-btn' onClick={handleDownload}> Download </div>
            </div>
        </div>
    )
}
export default DownloadBrochure


